// import $ from "jquery";
import baseClass from "./base";
import toolsBootstrap from "./toolsBootstrap";

baseClass.OnReadyArrAdd(function () {
  $(".js_BS_showdialog")
    .off("click")
    .on('click', function (e) {
      e.stopPropagation();

      toolsBootstrap.bsShowDialog($(this));
    });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_BS_closedialog")
    .off("click")
    .on('click', function (e) {
      e.stopPropagation();

      toolsBootstrap.bsCloseDialog($(this));
    });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_BS_carousel").each(function () {
    
      if ($(this).hasClass("true-bs-c")) return;
      $(this).addClass("true-bs-c");

      toolsBootstrap.bsSetCarousel($(this));
    });
});
